import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'followersTab', 'followingTab', 'followersPanel', 'followingPanel']

  openFollowers () {
    this.showFollowers()
    this.dialogTarget.show()
  }

  openFollowing () {
    this.showFollowing()
    this.dialogTarget.show()
  }

  close () {
    this.dialogTarget.hide()
  }

  showFollowers () {
    this.followersPanelTarget.classList.remove('hidden')
    this.followingPanelTarget.classList.add('hidden')
    this.activateTab(this.followersTabTarget, this.followingTabTarget)
  }

  showFollowing () {
    this.followingPanelTarget.classList.remove('hidden')
    this.followersPanelTarget.classList.add('hidden')
    this.activateTab(this.followingTabTarget, this.followersTabTarget)
  }

  activateTab (activeTab, inactiveTab) {
    activeTab.classList.add('border-ao-green', 'text-ao-brown')
    activeTab.classList.remove('border-transparent', 'text-zinc-500')
    inactiveTab.classList.remove('border-ao-green', 'text-ao-brown')
    inactiveTab.classList.add('border-transparent', 'text-zinc-500')
  }
}
